"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumberWithCommas = void 0;
const formatNumberWithCommas = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
exports.formatNumberWithCommas = formatNumberWithCommas;